// @ts-strict-ignore
import styled from "styled-components";

import { ContentContainer } from "components/layout/Layout";
import Button from "components/parts/button";
import { m } from "framer-motion";
import { Grid } from "components/layout/Grid";
import { Paragraph2 } from "components/parts/Typography/cryptopedia";
import { Flex } from "@hubble/web";

export const BackToGeminiSubNav = styled.div`
  margin: 0 !important;
  position: fixed;
  z-index: 11;
  height: 36px;
  background-color: #e9e5ff;
  top: 0;
  left: 0;
  width: 100vw;
`;
export const BackToGeminiSubNavInner = styled(Flex)`
  box-sizing: border-box;
  max-width: 1264px;
  margin: auto;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  padding-right: 3rem;
  padding-left: 2rem;
`;

export const HeaderContainer = styled(ContentContainer)`
  background-color: white;
`;

export const MobileHeaderBodyContainer = styled(Grid)`
  ${({ theme }) => theme.media.tablet`
    display: none;
  `}
`;

export const HeaderBodyContainer = styled(Grid)`
  border-bottom: 1px solid ${({ theme }) => theme.borderColors.secondary};
  display: none;
  ${({ theme }) => theme.media.tablet`
    display: block;
  `}
`;

export const SubscribeButton = styled(Button)`
  height: 40px;
  width: 120px;
  font-size: 14px;
  padding: 0 8px;
`;

export const MobileSearchContainer = styled(m.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: ${({ theme }) => theme.backgroundColors.primary};
  bottom: 0;
  padding: 48px 32px;
  z-index: 100;
`;

export const MobileSearchBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
`;

export const MobileSearchBar = styled.input`
  border: none;
  width: 100%;
  padding: 16px 40px 16px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.borderColors.secondary};
  background: transparent;
  border-radius: 0;
`;

export const SearchCancelButton = styled(Paragraph2)`
  &:hover,
  :active {
    text-decoration: underline;
  }
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  margin: 0;
`;

export const MobileSearchSuggestions = styled.div`
  padding: 24px 0px;
`;

export const MobileSearchSuggestion = styled(Paragraph2)`
  margin: 0 -32px;
  padding: 16px 64px;
  &:hover,
  &:active {
    background: ${({ theme }) => theme.backgroundColors.secondary};
  }
  background: ${({ highlighted, theme }) =>
    highlighted ? theme.backgroundColors.secondary : "transparent"};
`;

export const ModalHeader = styled.div`
  text-align: center;
  padding: 16px 0;
`;

export const NavRowItem = styled.div`
  position: relative;
  background: white;
  z-index: 8;
`;
